import { View, ActivityIndicator, StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { TierBody } from "@dramadetector/ui";
import { useTranslation } from "@dramadetector/shared";

/**
 * Loading state component for shared links
 */
export function SharedLinkLoading() {
  const { t } = useTranslation("home");

  return (
    <View style={styles.container}>
      <LinearGradient
        colors={["#0a0012", "#1a0a2e", "#0d1117"]}
        style={StyleSheet.absoluteFill}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
      />
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#ff00ff" />
        <TierBody size="base" style={styles.loadingText}>
          {t("home.modern.loading_results", {
            defaultValue: "Loading analysis...",
          })}
        </TierBody>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
  },
  loadingText: {
    marginTop: 16,
    color: '#9CA3AF',
  },
});
